import { render, staticRenderFns } from "./RecycleTraineeModal.vue?vue&type=template&id=64b8af30"
import script from "./RecycleTraineeModal.vue?vue&type=script&lang=js"
export * from "./RecycleTraineeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports